/* src/app/account/account-allocations/account-allocations-container/account-allocations-container.component.scss */
body#themeTag :host ::ng-deep .sticky-table-container .p-datatable {
  height: 100%;
  max-height: calc(100vh - 350px);
}
/*# sourceMappingURL=account-allocations-container.component.css.map */
